// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,
    default_published_url: "app-rc.gurumatch.com.br",
    default_subscription_id: "07b088fb-7db5-4f6b-ae31-6bf9e167b1ce",
    bucket: "gurumatch-rc",
    admin: {
        url: "https://api-admin-rc.gurumatch.com.br",
        client_id: ""
    },
    billing: {
        url: "https://api-billing-rc.gurumatch.com.br"
    },
    fiscal: {
        url: "https://api-fiscal-rc.gurumatch.com.br"
    },
    identity: {
        url: "https://api-identity-rc.gurumatch.com.br",
        client_id: ""
    },
    subscription: {
        url: "https://api-subscriptions-rc.gurumatch.com.br"
    },
    storage: {
        url: "https://api-storage-rc.gurumatch.com.br"
    },
    gamification: {
        url: "https://api-gamification-rc.gurumatch.com.br"
    },
    communication: {
        url: "https://api-communication-rc.gurumatch.com.br"
    },
    userCourses: {
        url: "https://api-user-courses-rc.gurumatch.com.br"
    },
    user: {
        url: "https://api-user-rc.gurumatch.com.br"
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
